import RendezyouLogoFull from './logo/splashLogo.png';

const LogoFull = () => {
  return <img src={RendezyouLogoFull} width={150}/>;
};

export default LogoFull;
